import { SUPPORTED_UI_LANGUAGES, type SupportedUiLanguage } from "../../onboarding/constants";
import {
  AR_ACCOUNT_UI_COPY,
  AR_BACKEND_SMOKE_COPY,
  AR_COPY,
  AR_MICROPHONE_PERMISSION_COPY,
  AR_PROVIDER_INTERACTIVE_PROMPT_COPY,
  AR_REMOTE_AUDIO_INSTALL_SMOKE_COPY,
  AR_REWARDED_AD_UNLOCK_SMOKE_COPY,
  AR_REWARDED_UNLOCK_PROMPT_COPY,
  AR_SETUP_LEVEL_SUBTITLES,
} from "./appCopy.ar.generated";

export interface Copy {
  appKicker: string;
  appTitle: string;
  setupStep: string;
  setupLanguagePairTitle: string;
  setupAppLanguageLabel: string;
  setupLanguagePairHint: string;
  setupSpeakLabel: string;
  setupPracticeLabel: string;
  setupPickerPlaceholder: string;
  setupContinue: string;
  setupLanguagePairConflictHint: string;
  setupLanguageApplyingTitle: string;
  setupLanguageApplyingHint: string;
  setupLanguagePairSummaryTitle: string;
  setupLanguagePairNativeSummary: string;
  setupLanguagePairTargetSummary: string;
  setupNativeTitle: string;
  setupNativeHint: string;
  setupTargetTitle: string;
  setupTargetHint: string;
  setupEnglishAccentTitle: string;
  setupEnglishAccentHint: string;
  setupAccentAmerican: string;
  setupAccentBritish: string;
  setupLevelTitle: string;
  setupLevelHint: string;
  setupLevelReadyTag: string;
  setupLevelLockedTag: string;
  setupLevelOnlyA1Hint: string;
  setupNativeLanguageLabel: string;
  setupNativeLanguageChange: string;
  nativeLanguageConfirmTitle: string;
  nativeLanguageConfirmQuestion: string;
  nativeLanguageConfirmHint: string;
  nativeLanguageConfirmCancel: string;
  nativeLanguageConfirmConfirm: string;
  setupLevelConfirmHint: string;
  setupLevelConfirmCancel: string;
  setupLevelConfirmLoad: string;
  setupLevelConfirmLoading: string;
  domainContentPromptTitle: string;
  domainContentPromptQuestion: string;
  domainContentPromptHint: string;
  domainContentPromptInstall: string;
  domainContentPromptInstalling: string;
  domainContentPromptError: string;
  cancelLabel: string;
  okLabel: string;
  setupDownloadTitle: string;
  setupDownloadHint: string;
  setupReadyTitle: string;
  setupReadyHint: string;
  targetLabel: string;
  levelLabel: string;
  requiredPacks: string;
  scenarios: string;
  sentences: string;
  estimatedSize: string;
  downloadNow: string;
  downloading: string;
  startLearning: string;
  restartSetup: string;
  sessionTitle: string;
  sessionHint: string;
  changeSetup: string;
  changeDomain: string;
  backToLevelScreen: string;
  domainLabel: string;
  scenarioLabel: string;
  learnLabel: string;
  practiceLabel: string;
  dialogueLabel: string;
  resultLabel: string;
  previous: string;
  next: string;
  learnTitle: string;
  learnHint: string;
  learnRoleSwitchYes: string;
  learnRoleSwitchNo: string;
  contextLabel: string;
  listen: string;
  practiceTitle: string;
  practiceHint: string;
  practiceActionLead: string;
  practiceActionStepRead: string;
  practiceActionStepSpeak: string;
  practiceActionDone: string;
  dialogueTitle: string;
  dialogueHint: string;
  dialogueYourTurn: string;
  resultTitle: string;
  resultHint: string;
  resultRestartLesson: string;
  audioPlaying: string;
  audioError: string;
  packMissingTitle: string;
  packMissingHint: string;
  goDownload: string;
  genericError: string;
  startupFailureTitle: string;
  startupFailureBody: string;
  startupRetry: string;
  startupRepairNavigation: string;
  startupRepairHint: string;
  startupDiagnosticLabel: string;
  pickDomainTitle: string;
  pickDomainHint: string;
  pickScenarioTitle: string;
  pickScenarioHint: string;
  pickModeTitle: string;
  pickModeHint: string;
  pickVocabularyTitle: string;
  pickVocabularyHint: string;
  pickVocabularyExercisesTitle: string;
  pickVocabularyExercisesHint: string;
  startScenarioLesson: string;
  changeScenario: string;
  translationMissing: string;
  dialogLabel: string;
  listenDialogue: string;
  learnNextDialogue: string;
  learnOpenDetails: string;
  learnBackToDialogues: string;
  practiceTryVoice: string;
  practiceStopVoice: string;
  practiceListening: string;
  practiceProcessing: string;
  practiceTranscript: string;
  practiceClarity: string;
  practiceTaskFit: string;
  practiceTaskFitMatch: string;
  practiceTaskFitMismatch: string;
  practiceTaskFitUnknown: string;
  practiceBandPass: string;
  practiceBandLow: string;
  practiceBandFail: string;
  practiceVoiceUnavailable: string;
  practiceSpeechPermissionDenied: string;
  practiceSpeechNoMatch: string;
  practiceSpeechModelPreparing: string;
  practiceSpeechBusy: string;
  practiceNextSentence: string;
  assistedProgressAction: string;
  assistedProgressHint: string;
  practiceChapterLabel: string;
  practiceIntroFallbackHint: string;
  practiceLockedShortAdLabel: string;
  practiceLockedLabel: string;
  practiceStartChapterAction: string;
  practiceChapterCompleteTitle: string;
  practiceChapterCompleteFinalHint: string;
  practiceChapterCompleteNextHint: string;
  practiceReplayChapterAction: string;
  practiceGoToMissionsAction: string;
  practiceNextChapterAction: string;
  practiceCollectedLabel: string;
  practiceTargetSentenceLabel: string;
  practiceNoIntentContentState: string;
  practiceNoSentenceState: string;
  vocabularyAudioLabel: string;
  missionAudioLabel: string;
  sectionAudioLabel: string;
  sentenceAudioLabel: string;
  audioUnlockPromptTitle: string;
  audioUnlockPromptMessageTemplate: string;
  audioUnlockPromptCancelLabel: string;
  audioUnlockPromptConfirmLabel: string;
  audioOpenUnavailableTitle: string;
  audioSectionRelockedTitle: string;
  audioSectionRelockedMessage: string;
  simulationSupportHint: string;
  simulationLearnerAction: string;
  simulationShowHint: string;
  simulationShowAnswer: string;
  simulationHintTitle: string;
  simulationAnswerTitle: string;
  simulationTaskTitle: string;
  simulationCompletionRequired: string;
  simulationListenFlow: string;
  simulationMissionLabel: string;
  simulationSceneLabel: string;
  simulationGoalLabel: string;
  simulationExpectedSentenceLabel: string;
  simulationStartTitle: string;
  simulationStartPromptRespond: string;
  simulationStartPromptInitiate: string;
  simulationChoiceHint: string;
  simulationStartButton: string;
  simulationPreviewReadyButton: string;
  simulationNextTask: string;
  simulationFinishFlow: string;
  simulationWaitLabel: string;
  simulationYourTurnLabel: string;
  simulationReadyNextLabel: string;
  simulationStartRequired: string;
  simulationPreviewListenRequired: string;
  simulationPreviewReadyLabel: string;
  simulationPreviewProgressLabel: string;
  simulationAutoCountdownLabel: string;
  simulationPreviewSceneGoalBadge: string;
  simulationPreviewDialogueBadge: string;
  simulationRetryButton: string;
  simulationRetryWrongOption: string;
  simulationRetryExactMatch: string;
  simulationRetryNotClear: string;
  simulationPrefixScopeNote: string;
  simulationCompleteTitle: string;
  simulationCompleteHint: string;
  simulationNoStepState: string;
  flowLabel: string;
  languageTurkish: string;
  languageEnglish: string;
  speakerLearner: string;
  speakerGuide: string;
  domainSocialInteraction: string;
  domainDailyLife: string;
  domainServicesPublic: string;
  domainCommunicationRepair: string;
  microSkillLabel: string;
  contextsLabel: string;
  progressLabel: string;
  sequentialRecommendationTitle: string;
  sequentialRecommendationMessageTemplate: string;
  openRecommendedLabel: string;
  openAnywayLabel: string;
  showAllChoices: string;
  missionStatsAccuracy: string;
  missionStatsFluency: string;
  missionStatsStars: string;
  missionStatsXp: string;
  diamondsLabel: string;
  xpLabel: string;
  missionStatsStreak: string;
  statusCompleted: string;
  statusInProgress: string;
  statusNew: string;
  scenarioTapHint: string;
  modeTapHint: string;
  openNowTag: string;
  signInRewardedTag: string;
  guestStarterHint: string;
  vocabularyUnlockHint: string;
  vocabularyLabel: string;
  modeCardLearnContent: string;
  modeCardPracticeContent: string;
  modeCardVocabularyContent: string;
  modeCardMissionsContent: string;
  modeStatsDialogues: string;
  modeStatsPrompts: string;
  modeStatsWords: string;
  modeStatsMissions: string;
  modeStatsReviewed: string;
  modeStatsCompleted: string;
  mixedMissionsTitle: string;
  mixedMissionsHint: string;
  mixedMissionsLoadingTitle: string;
  mixedMissionsLoadingHint: string;
  mixedMissionsEmptyTitle: string;
  mixedMissionsEmptyHint: string;
  mixedMissionsReadyTag: string;
  mixedMissionsUnavailableTag: string;
  mixedMissionsOpenAction: string;
  mixedMissionsStartMixedAction: string;
  mixedMissionsPickMissionAction: string;
  mixedMissionsPickerTitle: string;
  mixedMissionsPickerCloseAction: string;
  mixedMissionsAllLevelsFilter: string;
  mixedMissionsLevelFilterLabel: string;
  vocabularyStudioTitle: string;
  vocabularyStudioHint: string;
  vocabularyExercisesTitle: string;
  vocabularyExercisesHint: string;
  vocabularyExerciseListenRepeatTitle: string;
  vocabularyExerciseListenRepeatHint: string;
  vocabularyExerciseUnscrambleTitle: string;
  vocabularyExerciseUnscrambleHint: string;
  vocabularyExerciseListenWriteTitle: string;
  vocabularyExerciseListenWriteHint: string;
  vocabularyPreviewTitle: string;
  vocabularyAudioReadyLabel: string;
  vocabularyAudioPendingLabel: string;
  vocabularyContextUnit: string;
  vocabularyEmptyState: string;
  vocabularyStartAction: string;
  vocabularyRestartAction: string;
  vocabularyCheckAction: string;
  vocabularyNextWordAction: string;
  vocabularyExamplesAction: string;
  vocabularyHideExamplesAction: string;
  vocabularyWordLabel: string;
  vocabularyExamplesLabel: string;
  vocabularyNoExamplesState: string;
  vocabularyListenAction: string;
  vocabularyStopAction: string;
  vocabularyRecognizedLabel: string;
  vocabularyWritePlaceholder: string;
  vocabularyYourAnswerLabel: string;
  vocabularyCorrectAnswerLabel: string;
  vocabularyScoreLabel: string;
  vocabularyHintOneAction: string;
  vocabularyHintTwoAction: string;
  vocabularyGiveUpAction: string;
  vocabularyClearAction: string;
  vocabularyBackspaceAction: string;
  vocabularySpellingHintAction: string;
  vocabularyMeaningHintLabel: string;
  vocabularyAudioHintLabel: string;
  vocabularyAudioHintPlayed: string;
  vocabularyFeedbackCorrect: string;
  vocabularyFeedbackIncorrect: string;
  vocabularyFeedbackGiveUp: string;
  vocabularyFeedbackHintLabel: string;
  vocabularyFeedbackListenRepeatHint: string;
  vocabularyFeedbackListenWriteHint: string;
  vocabularyFeedbackUnscrambleHint: string;
  vocabularyFeedbackCloseAction: string;
  clarityRailLabel: string;
  rewardCollectedLabel: string;
  diamondCollectedLabel: string;
  statusListeningLabel: string;
  statusProcessingLabel: string;
  statusEvaluatingLabel: string;
  retryShortLabel: string;
  genericStatusLabel: string;
  genericFeedbackLabel: string;
  practiceRailListeningHint: string;
  practiceRailProcessingHint: string;
  practiceRailPassRewardHint: string;
  practiceRailPassXpHint: string;
  practiceRailPassReviewHint: string;
  practiceRailRetryHint: string;
  missionRailListeningHint: string;
  missionRailProcessingHint: string;
  missionRailPassRewardHint: string;
  missionRailPassContinueHint: string;
  missionRailIdleHint: string;
  simulationLiveFeedbackListening: string;
  simulationLiveFeedbackProcessing: string;
  fullScreenPreviousMissionLabel: string;
  fullScreenNextMissionLabel: string;
  fullScreenPreviousSentenceLabel: string;
  fullScreenNextSentenceLabel: string;
  vocabularyTryAgainHint: string;
  translateAction: string;
  hideTranslation: string;
  translationLoading: string;
  translationError: string;
  noScenarioSelectedError: string;
  firstUseGuideTitle: string;
  firstUseGuideStepLabel: string;
  firstUseGuideSkip: string;
  firstUseGuideNext: string;
  firstUseGuideDone: string;
  firstUseGuideSteps: FirstUseGuideStepCopy[];
  controlledTrialProgressLabel: string;
  controlledTrialStart: string;
  controlledTrialStarting: string;
  controlledTrialPreparing: string;
  controlledTrialLockedTag: string;
  controlledTrialBlockedTitle: string;
  controlledTrialBlockedBody: string;
  controlledTrialBlockedAction: string;
  controlledTrialCompletionTitle: string;
  controlledTrialCompletionBody: string;
  controlledTrialCompletionItems: string[];
  controlledTrialCompletionAction: string;
  controlledTrialStages: FirstUseGuideStepCopy[];
  controlledTrialVocabularyStages: FirstUseGuideStepCopy[];
  contextGuideDomainTitle: string;
  contextGuideDomainSteps: FirstUseGuideStepCopy[];
  contextGuideModeTitle: string;
  contextGuideModeSteps: FirstUseGuideStepCopy[];
  contextGuidePracticeTitle: string;
  contextGuidePracticeSteps: FirstUseGuideStepCopy[];
  contextGuideVocabularyTitle: string;
  contextGuideVocabularySteps: FirstUseGuideStepCopy[];
  contextGuideMissionsTitle: string;
  contextGuideMissionsSteps: FirstUseGuideStepCopy[];
  contextGuideMixedMissionsTitle: string;
  contextGuideMixedMissionsSteps: FirstUseGuideStepCopy[];
  quickAccessOpenLabel: string;
  quickAccessCloseLabel: string;
  quickAccessTitle: string;
  quickAccessHint: string;
  quickAccessLanguageSettingsLabel: string;
  quickAccessCurrentScenario: string;
  quickAccessMixedMissions: string;
  quickAccessUnavailableHint: string;
}

export interface FirstUseGuideStepCopy {
  title: string;
  body: string;
}

export interface SetupLevelSubtitleCopy {
  a1: string;
  a2: string;
  b1: string;
  b2: string;
}

export interface BackendSmokeCopy {
  title: string;
  run: string;
  idle: string;
  running: string;
  success: string;
  error: string;
  hint: string;
  uid: string;
  attemptId: string;
  endpoint: string;
  authPresent: string;
  providerIds: string;
  downloadAuthorized: string;
  authorizationSource: string;
  scenario: string;
  errorCode: string;
  phase: string;
}

export interface RemoteAudioInstallSmokeCopy {
  title: string;
  run: string;
  idle: string;
  running: string;
  success: string;
  error: string;
  hint: string;
  uid: string;
  providerIds: string;
  authorizationSource: string;
  fileStoreVerified: string;
  audioRefCount: string;
  newlyInstalledAudioRefCount: string;
  alreadyInstalledAudioRefCount: string;
  playableSourceKind: string;
  playableUri: string;
  storageUnitKey: string;
  scenario: string;
  errorCode: string;
  phase: string;
}

export interface RewardedAdUnlockSmokeCopy {
  title: string;
  run: string;
  idle: string;
  running: string;
  success: string;
  error: string;
  hint: string;
  uid: string;
  providerIds: string;
  kind: string;
  grantedReceiptActive: string;
  rewardStatus: string;
  adUnitId: string;
  audioRefCount: string;
  newlyInstalledAudioRefCount: string;
  alreadyInstalledAudioRefCount: string;
  fileStoreVerified: string;
  playableSourceKind: string;
  playableUri: string;
  storageUnitKey: string;
  scenario: string;
  errorCode: string;
  phase: string;
}

export interface RewardedUnlockPromptCopy {
  title: string;
  message: string;
  cancelLabel: string;
  confirmLabel: string;
}

export interface ProviderInteractivePromptCopy {
  title: string;
  messageTemplate: string;
  confirmLabel: string;
  cancelLabel: string;
}

export interface MicrophonePermissionCopy {
  title: string;
  message: string;
  buttonPositive: string;
  buttonNegative: string;
}

export interface AccountUiCopy {
  domainButton: string;
  title: string;
  hint: string;
  noteAndroid: string;
  noteIos: string;
  back: string;
  status: string;
  notSignedIn: string;
  signedIn: string;
  checking: string;
  signingIn: string;
  signingOut: string;
  deletingAccount: string;
  authError: string;
  phase: string;
  approvedProvider: string;
  level: string;
  spokenLanguage: string;
  changeSpokenLanguage: string;
  targetLanguage: string;
  signedInBody: string;
  signedOutBody: string;
  guestAccessTitle: string;
  guestAccessBody: string;
  protectedFeaturesTitle: string;
  protectedFeaturesBody: string;
  premiumTitle: string;
  premiumBody: string;
  premiumActionLabel: string;
  premiumRestoreLabel: string;
  premiumManageLabel: string;
  premiumRestoreEmptyMessage: string;
  premiumSubscriptionPeriodLabel: string;
  premiumSubscriptionPeriodValue: string;
  premiumSubscriptionPriceLabel: string;
  premiumSubscriptionPriceFallback: string;
  premiumSubscriptionIncludedLabel: string;
  premiumSubscriptionIncludedValue: string;
  premiumSubscriptionRenewalNote: string;
  premiumRestoreHint: string;
  premiumLegalText: string;
  premiumTermsLabel: string;
  premiumPrivacyLabel: string;
  adPrivacyOptionsLabel: string;
  planLabel: string;
  planFreeValue: string;
  planPremiumValue: string;
  adsLabel: string;
  adsOnValue: string;
  adsOffValue: string;
  premiumStatusLabel: string;
  premiumStatusInactiveValue: string;
  premiumStatusActiveValue: string;
  premiumStatusGraceValue: string;
  premiumCheckoutLabel: string;
  premiumCheckoutReadyValue: string;
  premiumCheckoutPreparingValue: string;
  premiumCheckoutUnavailableValue: string;
  remindersTitle: string;
  remindersBody: string;
  remindersStatusLabel: string;
  remindersOnValue: string;
  remindersOffValue: string;
  remindersPermissionDeniedValue: string;
  remindersEnableLabel: string;
  remindersDisableLabel: string;
  remindersPreviewLabel: string;
  remindersFrequencyLabel: string;
  remindersDailyValue: string;
  remindersWeeklyValue: string;
  remindersChangeFrequencyLabel: string;
  remindersTimeLabel: string;
  remindersChangeTimeLabel: string;
  remindersScheduledLabel: string;
  remindersNotScheduledValue: string;
  remindersPermissionPromptTitle: string;
  remindersPermissionPromptMessage: string;
  remindersPermissionPromptConfirm: string;
  remindersPermissionPromptCancel: string;
  appearanceTitle: string;
  settingsTitle: string;
  appearanceBody: string;
  appearanceModeLabel: string;
  appearanceDarkValue: string;
  appearanceLightValue: string;
  appearanceFrequencyValue: string;
  monetizationCheckingValue: string;
  uid: string;
  providerIds: string;
  signInGoogle: string;
  signInApple: string;
  refreshSession: string;
  signOut: string;
  lazyPromptTitle: string;
  lazyPromptMessage: string;
  lazyPromptConfirm: string;
  lazyPromptCancel: string;
  errorTitle: string;
  signOutConfirmTitle: string;
  signOutConfirmMessage: string;
  signOutConfirmCancel: string;
  signOutConfirmApprove: string;
  deleteAccountTitle: string;
  deleteAccountBody: string;
  deleteAccountAction: string;
  deleteAccountConfirmTitle: string;
  deleteAccountConfirmMessage: string;
  deleteAccountConfirmCancel: string;
  deleteAccountConfirmApprove: string;
  deleteAccountSuccessTitle: string;
  deleteAccountSuccessMessage: string;
  providerGoogleLabel: string;
  providerAppleLabel: string;
  providerGenericLabel: string;
}

export const COPY: Record<SupportedUiLanguage, Copy> = {
  ar: AR_COPY,
  tr: {
    appKicker: "Wordinarius Echo",
    appTitle: "Konuşma Eğitmeni",
    setupStep: "Adım",
    setupLanguagePairTitle: "Dil çiftini seç",
    setupAppLanguageLabel: "Uygulama dili",
    setupLanguagePairHint: "",
    setupSpeakLabel: "Konuştuğum dil",
    setupPracticeLabel: "Öğrenmek istediğim dil",
    setupPickerPlaceholder: "Dil seç",
    setupContinue: "Devam",
    setupLanguagePairConflictHint: "Bu destek dili için şu anda kullanılabilir pratik dili yok.",
    setupLanguageApplyingTitle: "Dil kurulumu yapılıyor",
    setupLanguageApplyingHint: "Seviye ekranını açmadan önce dil paketleri ve çalışma alanları hazırlanıyor.",
    setupLanguagePairSummaryTitle: "Seçimini kontrol et",
    setupLanguagePairNativeSummary: "Konuştuğum dil",
    setupLanguagePairTargetSummary: "Çalışacağım dil",
    setupNativeTitle: "Hangi dilde destek almak istiyorsun?",
    setupNativeHint: "Yönlendirmeler ve ipuçları bu dilde gösterilir.",
    setupTargetTitle: "Hangi dili öğrenmek istiyorsun?",
    setupTargetHint: "Çalışma boyunca bu dilde konuşacaksın.",
    setupEnglishAccentTitle: "İngilizce aksanı",
    setupEnglishAccentHint: "Dinleme ve konuşma değerlendirmesinde kullanmak istediğin aksanı seç.",
    setupAccentAmerican: "Amerikan İngilizcesi",
    setupAccentBritish: "Britanya İngilizcesi",
    setupLevelTitle: "Hangi seviyeden başlayalım?",
    setupLevelHint: "Temelden sağlam gitmek için ilk seviye ile başla.",
    setupLevelReadyTag: "Aktif",
    setupLevelLockedTag: "Yakında",
    setupLevelOnlyA1Hint: "A1, A2, B1 ve B2 şu an aktif.",
    setupNativeLanguageLabel: "Konuştuğum dil",
    setupNativeLanguageChange: "Değiştir",
    nativeLanguageConfirmTitle: "Konuştuğum dili onayla",
    nativeLanguageConfirmQuestion: "Yönlendirmeler ve ipuçları {languageName} olsun mu?",
    nativeLanguageConfirmHint: "Bu seçim, hedef dildeki içeriklere bayrakla verilen dil desteğini de belirler.",
    nativeLanguageConfirmCancel: "Değiştir",
    nativeLanguageConfirmConfirm: "Evet, seç",
    setupLevelConfirmHint: "Devam ettiğinde doğrudan çalışma alanlarına geçeceksin.",
    setupLevelConfirmCancel: "İptal",
    setupLevelConfirmLoad: "Devam et",
    setupLevelConfirmLoading: "Açılıyor...",
    domainContentPromptTitle: "İçerik paketi",
    domainContentPromptQuestion: "Bu alanın senaryo içerikleri indirilsin mi?",
    domainContentPromptHint: "Sadece seçtiğin seviye ve çalışma alanının metin paketi hazırlanır. Ses dosyaları gerektiğinde ayrıca açılır.",
    domainContentPromptInstall: "İndir",
    domainContentPromptInstalling: "İçerik hazırlanıyor...",
    domainContentPromptError: "Bu içerik paketi şu an hazırlanamadı.",
    cancelLabel: "İptal",
    okLabel: "Tamam",
    setupDownloadTitle: "Gerekli öğrenme paketlerini indir",
    setupDownloadHint: "Sadece seçtiğin dil ve seviyenin gerekli dosyaları iner.",
    setupReadyTitle: "Her şey hazır",
    setupReadyHint: "Önce nasıl konuşulduğunu görecek, sonra pratik yapacaksın.",
    targetLabel: "Hedef dil",
    levelLabel: "Seviye",
    requiredPacks: "Gerekli paket",
    scenarios: "senaryo",
    sentences: "cümle",
    estimatedSize: "Tahmini boyut",
    downloadNow: "Şimdi indir",
    downloading: "İndiriliyor",
    startLearning: "Öğrenmeye başla",
    restartSetup: "Kurulumu baştan yap",
    sessionTitle: "Bugünkü ders",
    sessionHint: "Akış: Öğren -> Pratik -> Görevler -> Sonuç",
    changeSetup: "Kurulumu değiştir",
    changeDomain: "Farklı alan seç",
    backToLevelScreen: "Seviye ekranına dön",
    domainLabel: "Çalışma alanı",
    scenarioLabel: "Senaryo",
    learnLabel: "Öğren",
    practiceLabel: "Pratik",
    vocabularyLabel: "Kelime",
    dialogueLabel: "Görevler",
    resultLabel: "Sonuç",
    previous: "Geri",
    next: "Devam",
    learnTitle: "1) Önce doğru kullanımını gör",
    learnHint: "Örnek diyaloğu dinle, kalıpları nerede kullanacağını netleştir.",
    learnRoleSwitchYes: "Bu senaryoda hem soru sorma hem cevap verme rolleri var.",
    learnRoleSwitchNo: "Bu senaryo tek role odaklanır, diğer rol ayrı senaryoda pekiştirilir.",
    contextLabel: "Bağlam",
    listen: "Dinle",
    practiceTitle: "2) Şimdi sen söyle",
    practiceHint: "Aşağıdaki kalıpları sesli tekrar ederek doğal akıcılık kazan.",
    practiceActionLead: "Mikrofona bas ve cümleyi sesli söyle.",
    practiceActionStepRead: "1) Cümleyi oku",
    practiceActionStepSpeak: "2) Alttaki mikrofona bas ve test et",
    practiceActionDone: "Tamamlandı",
    dialogueTitle: "3) Gerçek hayat görevleri",
    dialogueHint: "Göreve başlamadan sahneyi incele ve beklenen cümleyi sesli üret.",
    dialogueYourTurn: "Senin sıran",
    resultTitle: "4) Ders özeti",
    resultHint: "Bu senaryonun temel kalıplarını gördün ve uyguladın.",
    resultRestartLesson: "Dersi baştan al",
    audioPlaying: "Ses oynatılıyor",
    audioError: "Ses şu an açılamadı. Lütfen tekrar dene.",
    packMissingTitle: "Gerekli paket hazır değil",
    packMissingHint: "Bu alana geçmeden önce gerekli dosyaların inmesi gerekiyor.",
    goDownload: "İndirme adımına dön",
    genericError: "İçerik şu an yüklenemedi.",
    startupFailureTitle: "Uygulama açılamadı",
    startupFailureBody: "Tekrar deneyebilir veya yalnızca kayıtlı ekran konumunu yenileyebilirsin.",
    startupRetry: "Tekrar dene",
    startupRepairNavigation: "Gezinmeyi yenile",
    startupRepairHint: "İlerlemen, indirilen içerikler ve hesap bilgilerin korunur.",
    startupDiagnosticLabel: "Tanılama kodu",
    pickDomainTitle: "Çalışma alanını seç",
    pickDomainHint: "Önce bir alan seç.",
    pickScenarioTitle: "Senaryonu seç",
    pickScenarioHint: "Sıralı ilerlemek için bir senaryo seç ve devam et.",
    pickModeTitle: "Öğrenme modunu seç",
    pickModeHint: "Önerilen sıra: önce cümle pratiği, sonra kelime pratiği, en son görevler.",
    pickVocabularyTitle: "Kelime pratiğini seç",
    pickVocabularyHint: "Kelime stüdyosuna ya da kelime alıştırmalarına geçmek için bir kart seç.",
    pickVocabularyExercisesTitle: "Kelime alıştırmalarını seç",
    pickVocabularyExercisesHint: "Bu senaryo için hangi egzersizle başlamak istediğini seç.",
    startScenarioLesson: "Bu senaryoya başla",
    changeScenario: "Farklı senaryo seç",
    translationMissing: "Bu destek metni henüz hazır değil.",
    dialogLabel: "Diyalog",
    listenDialogue: "Diyaloğu dinle",
    learnNextDialogue: "Sonraki diyalog",
    learnOpenDetails: "Dil detaylarını göster",
    learnBackToDialogues: "Diyaloglara geri dön",
    practiceTryVoice: "Konuş ve test et",
    practiceStopVoice: "Kaydı durdur",
    practiceListening: "Dinleniyor... cümleyi şimdi söyle.",
    practiceProcessing: "Değerlendiriliyor...",
    practiceTranscript: "Duyduğumuz cümle",
    practiceClarity: "Netlik",
    practiceTaskFit: "Cümle eşleşmesi",
    practiceTaskFitMatch: "Eşleşiyor",
    practiceTaskFitMismatch: "Eşleşmiyor",
    practiceTaskFitUnknown: "Belirsiz",
    practiceBandPass: "Net",
    practiceBandLow: "Kısmen net",
    practiceBandFail: "Yetersiz netlik",
    practiceVoiceUnavailable: "Konuşma şu an başlatılamadı. Lütfen tekrar dene.",
    practiceSpeechPermissionDenied: "Mikrofon izni verilmeden konuşma testi başlatılamaz.",
    practiceSpeechNoMatch: "Ses algılanamadı. Daha net ve yakın konuşup tekrar dene.",
    practiceSpeechModelPreparing: "Türkçe konuşma modeli hazırlanıyor. Biraz bekleyip tekrar dene.",
    practiceSpeechBusy: "Konuşma algılama meşgul. Kısa bir beklemeden sonra tekrar dene.",
    practiceNextSentence: "Sonraki cümle",
    assistedProgressAction: "Sonrakine geç",
    assistedProgressHint: "Bu adım tamamlandı veya ödül kazanıldı olarak kaydedilmez.",
    practiceChapterLabel: "Bölüm",
    practiceIntroFallbackHint: "Bu bölümde kalıpları sırayla çalışacaksın.",
    practiceLockedShortAdLabel: "Reklamla açılır",
    practiceLockedLabel: "Kilitli",
    practiceStartChapterAction: "Çalışmaya başla",
    practiceChapterCompleteTitle: "Bölüm tamamlandı",
    practiceChapterCompleteFinalHint: "Tüm pratik bölümlerini tamamladın. İstersen şimdi diyalog görevlerine geçebilirsin.",
    practiceChapterCompleteNextHint: "Güzel ilerliyorsun. Hazırsan sıradaki bölüme geç.",
    practiceReplayChapterAction: "Bölümü tekrar et",
    practiceGoToMissionsAction: "Görevlere geç",
    practiceNextChapterAction: "Sıradaki bölüm",
    practiceCollectedLabel: "Toplanan",
    practiceTargetSentenceLabel: "Hedef cümle",
    practiceNoIntentContentState: "Bu senaryoda bölüm bazlı pratik içeriği bulunamadı.",
    practiceNoSentenceState: "Bu senaryoda pratik için uygun cümle bulunamadı.",
    vocabularyAudioLabel: "Kelime sesleri",
    missionAudioLabel: "Görev sesleri",
    sectionAudioLabel: "Bu bölümün sesleri",
    sentenceAudioLabel: "Bu cümlenin sesi",
    audioUnlockPromptTitle: "Bu paketi reklamla aç",
    audioUnlockPromptMessageTemplate:
      "Bir reklam, {unitLabel} paketini ücretsiz kullanıma açar ve bu cihaza indirir. Paket cihazda hazır kaldıkça aynı paket için yeniden reklam gerekmez.",
    audioUnlockPromptCancelLabel: "Şimdi değil",
    audioUnlockPromptConfirmLabel: "Reklamı izle ve aç",
    audioOpenUnavailableTitle: "Şu an açılamıyor",
    audioSectionRelockedTitle: "Bölüm yeniden kapandı",
    audioSectionRelockedMessage: "Gerekli sesler cihazda bulunamadığı için bu bölüm yeniden kapandı.",
    simulationSupportHint: "Sıra sana geldiğinde cümleyi söyle ve istersen hemen test et.",
    simulationLearnerAction: "Bu satırı sesli söyle",
    simulationShowHint: "İpucu göster",
    simulationShowAnswer: "Örnek cevabı göster",
    simulationHintTitle: "İpucu",
    simulationAnswerTitle: "Örnek cevap",
    simulationTaskTitle: "Görev",
    simulationCompletionRequired: "Devam etmek için görev adımındaki tüm görevleri tamamla.",
    simulationListenFlow: "Akışı dinle",
    simulationMissionLabel: "Görev",
    simulationSceneLabel: "Sahne",
    simulationGoalLabel: "Amaç",
    simulationExpectedSentenceLabel: "Beklenen cümle",
    simulationStartTitle: "Görev",
    simulationStartPromptRespond: "Dinle ve uygun ifadeyi söyle.",
    simulationStartPromptInitiate: "Konuşmayı sen başlat ve uygun ifadeyi söyle.",
    simulationChoiceHint: "A veya B seçeneklerinden doğru cümleyi sesli söyle.",
    simulationStartButton: "Hazırım",
    simulationPreviewReadyButton: "Diyaloğu gör",
    simulationNextTask: "Sonraki görev",
    simulationFinishFlow: "Görevleri bitir",
    simulationWaitLabel: "Bekle",
    simulationYourTurnLabel: "Sıra sende",
    simulationReadyNextLabel: "Hazır: Sonraki göreve geç",
    simulationStartRequired: "Önce görevi başlat.",
    simulationPreviewListenRequired: "Önce tüm satırları dinle",
    simulationPreviewReadyLabel: "Hazır: görevi başlat",
    simulationPreviewProgressLabel: "Dinlenen satırlar",
    simulationAutoCountdownLabel: "Mikrofon açılıyor",
    simulationPreviewSceneGoalBadge: "Görev",
    simulationPreviewDialogueBadge: "Diyaloğu gör",
    simulationRetryButton: "Tekrar dene",
    simulationRetryWrongOption: "Seni duydum ama bu görev için doğru seçenek bu değil. Lütfen tekrar dene.",
    simulationRetryExactMatch: "Lütfen sadece ekranda gösterilen cümleyi tam olarak söylemeye çalış.",
    simulationRetryNotClear: "Anlaşılamadı. Lütfen tekrar dene.",
    simulationPrefixScopeNote: "Bu denemede cümlenin sadece başlangıcı dikkate alındı.",
    simulationCompleteTitle: "Simülasyon tamamlandı",
    simulationCompleteHint: "Bu akış boyunca uygun cevaplarla ilerledin.",
    simulationNoStepState: "Bu senaryoda simüle edilecek öğrenci satırı bulunamadı.",
    flowLabel: "Görev",
    languageTurkish: "Türkçe",
    languageEnglish: "İngilizce",
    speakerLearner: "Sen",
    speakerGuide: "W-Echo",
    domainSocialInteraction: "Sosyal etkileşim",
    domainDailyLife: "Günlük hayat",
    domainServicesPublic: "Hizmetler / Kamu",
    domainCommunicationRepair: "İletişim onarımı",
    microSkillLabel: "Mikro beceri",
    contextsLabel: "Bağlamlar",
    progressLabel: "İlerleme",
    sequentialRecommendationTitle: "Sıralı ilerleme önerisi",
    sequentialRecommendationMessageTemplate: "Önce {scenarioNumber}. senaryoyu tamamlaman önerilir.",
    openRecommendedLabel: "Önerileni aç",
    openAnywayLabel: "Yine de aç",
    showAllChoices: "Tüm seçenekleri göster",
    missionStatsAccuracy: "Doğruluk",
    missionStatsFluency: "Akıcılık",
    missionStatsStars: "Yıldız",
    missionStatsXp: "XP",
    diamondsLabel: "W-Coin",
    xpLabel: "XP",
    missionStatsStreak: "Seri",
    statusCompleted: "Tamamlandı",
    statusInProgress: "Devam ediyor",
    statusNew: "Yeni",
    scenarioTapHint: "Dokun ve başla",
    modeTapHint: "Dokun ve aç",
    openNowTag: "Açık",
    signInRewardedTag: "Giriş + reklam",
    guestStarterHint: "İlk bölüm şimdi açık. Diğer ses paketleri gerektiğinde giriş yaptıktan sonra bir reklamla açılır.",
    vocabularyUnlockHint: "Kelime sesleri ayrı açılır. Kilitli kartlarda önce giriş yapman, sonra bir reklam izlemen gerekir.",
    modeCardLearnContent: "Örnek diyaloglar",
    modeCardPracticeContent: "Cümle pratiği",
    modeCardVocabularyContent: "Kelime pratiği",
    modeCardMissionsContent: "Görevler",
    modeStatsDialogues: "diyalog",
    modeStatsPrompts: "alıştırma",
    modeStatsWords: "kelime",
    modeStatsMissions: "görev",
    modeStatsReviewed: "İncelenen",
    modeStatsCompleted: "Tamamlanan",
    mixedMissionsTitle: "Karışık görevler",
    mixedMissionsHint: "Cihazda hazır olan görev seslerinden bir tekrar havuzu aç.",
    mixedMissionsLoadingTitle: "Görevler hazırlanıyor",
    mixedMissionsLoadingHint: "Cihazdaki indirilen görevler kontrol ediliyor. Birazdan burada görünecek.",
    mixedMissionsEmptyTitle: "Havuz henüz boş",
    mixedMissionsEmptyHint: "Bir senaryonun görev seslerini indirdikten sonra o görevler burada görünür.",
    mixedMissionsReadyTag: "Tekrar hazır",
    mixedMissionsUnavailableTag: "Henüz hazır değil",
    mixedMissionsOpenAction: "Görevi aç",
    mixedMissionsStartMixedAction: "Karışık görev başlat",
    mixedMissionsPickMissionAction: "Görev seç",
    mixedMissionsPickerTitle: "Görev seç",
    mixedMissionsPickerCloseAction: "Görev seçimini kapat",
    mixedMissionsAllLevelsFilter: "Tümü",
    mixedMissionsLevelFilterLabel: "Seviye filtresi",
    vocabularyStudioTitle: "Kelime stüdyosu",
    vocabularyStudioHint: "Kelimeleri tek tek dinle, yüksek sesle söyle ve tekrar et.",
    vocabularyExercisesTitle: "Kelime alıştırmaları",
    vocabularyExercisesHint: "Kelimeyi dinleme, yazma ve çözme odaklı egzersizlerden birini aç.",
    vocabularyExerciseListenRepeatTitle: "Dinle ve tekrar et",
    vocabularyExerciseListenRepeatHint: "Kelimeyi dinle, yüksek sesle söyle ve tekrar et.",
    vocabularyExerciseUnscrambleTitle: "Harfleri sırala",
    vocabularyExerciseUnscrambleHint: "Karışık harfleri doğru kelime sırasına getir.",
    vocabularyExerciseListenWriteTitle: "Dinle ve yaz",
    vocabularyExerciseListenWriteHint: "Duyduğun kelimeyi doğru biçimde yaz.",
    vocabularyPreviewTitle: "Ön izleme",
    vocabularyAudioReadyLabel: "Sesli",
    vocabularyAudioPendingLabel: "Ses bekleniyor",
    vocabularyContextUnit: "bağlam",
    vocabularyEmptyState: "Bu senaryoda kelime verisi henüz hazır değil.",
    vocabularyStartAction: "Başla",
    vocabularyRestartAction: "Tekrar başlat",
    vocabularyCheckAction: "Kontrol et",
    vocabularyNextWordAction: "Sonraki kelime",
    vocabularyExamplesAction: "Örnekler",
    vocabularyHideExamplesAction: "Örnekleri gizle",
    vocabularyWordLabel: "Kelime",
    vocabularyExamplesLabel: "Örnek cümleler",
    vocabularyNoExamplesState: "Bu kelime için örnek cümle bulunamadı.",
    vocabularyListenAction: "Dinle",
    vocabularyStopAction: "Durdur",
    vocabularyRecognizedLabel: "Algılanan kelime",
    vocabularyWritePlaceholder: "Duyduğun kelimeyi yaz",
    vocabularyYourAnswerLabel: "Cevabın",
    vocabularyCorrectAnswerLabel: "Doğru kelime",
    vocabularyScoreLabel: "XP",
    vocabularyHintOneAction: "İpucu 1",
    vocabularyHintTwoAction: "İpucu 2",
    vocabularyGiveUpAction: "Vazgeç",
    vocabularyClearAction: "Temizle",
    vocabularyBackspaceAction: "Sil",
    vocabularySpellingHintAction: "Harf ipucu",
    vocabularyMeaningHintLabel: "Dil desteği",
    vocabularyAudioHintLabel: "Ses ipucu",
    vocabularyAudioHintPlayed: "Kelimenin sesi çalındı. Tekrar dinleyebilirsin.",
    vocabularyFeedbackCorrect: "Doğru",
    vocabularyFeedbackIncorrect: "Henüz doğru değil",
    vocabularyFeedbackGiveUp: "Kelime gösterildi",
    vocabularyFeedbackHintLabel: "Çalışma ipucu",
    vocabularyFeedbackListenRepeatHint: "Sesi yeniden dinle. Kelimeyi parça parça söyle ve mikrofona yakın kal.",
    vocabularyFeedbackListenWriteHint: "Sesi yeniden dinle. Yazımı kontrol edip cevabını düzelt.",
    vocabularyFeedbackUnscrambleHint: "Hemen pes etme. İpuçlarını kullanıp harf sırasını daralt.",
    vocabularyFeedbackCloseAction: "Sonucu kapat",
    clarityRailLabel: "Netlik",
    rewardCollectedLabel: "ÖDÜL ALINDI",
    diamondCollectedLabel: "ÖDÜL ALINDI",
    statusListeningLabel: "Dinleniyor",
    statusProcessingLabel: "İşleniyor",
    statusEvaluatingLabel: "Değerlendiriliyor",
    retryShortLabel: "Tekrar dene",
    genericStatusLabel: "Durum",
    genericFeedbackLabel: "Geri bildirim",
    practiceRailListeningHint: "Sesin geldikçe netlik çubuğu doluyor.",
    practiceRailProcessingHint: "Son netlik skoru işleniyor.",
    practiceRailPassRewardHint: "Net söyledin. Ödül alındı.",
    practiceRailPassXpHint: "Net söyledin. Yeni XP işlendi.",
    practiceRailPassReviewHint: "Net söyledin. Tekrar çalışıldı.",
    practiceRailRetryHint: "Mikrofona dokunup aynı cümleyi tekrar deneyebilirsin.",
    missionRailListeningHint: "Cümlen geldikçe netlik çubuğu hareket edecek.",
    missionRailProcessingHint: "Son netlik skoru işleniyor.",
    missionRailPassRewardHint: "Netlik tam. Ödül alındı.",
    missionRailPassContinueHint: "Görev tamamlandı. Hazırsan devam et.",
    missionRailIdleHint: "Cümlen geldikçe netlik çubuğu hareket edecek.",
    simulationLiveFeedbackListening: "Cümleni söyle. Geri bildirim burada görünecek.",
    simulationLiveFeedbackProcessing: "Sonucun hazırlanıyor.",
    fullScreenPreviousMissionLabel: "Önceki görev",
    fullScreenNextMissionLabel: "Sonraki görev",
    fullScreenPreviousSentenceLabel: "Önceki cümle",
    fullScreenNextSentenceLabel: "Sonraki cümle",
    vocabularyTryAgainHint: "Cevabını düzenle ve yeniden kontrol et.",
    translateAction: "Çevir",
    hideTranslation: "Çeviriyi gizle",
    translationLoading: "Çeviri alınıyor...",
    translationError: "Çeviri şu an alınamadı.",
    noScenarioSelectedError: "Henüz bir senaryo seçilmedi.",
    firstUseGuideTitle: "Hızlı başlangıç",
    firstUseGuideStepLabel: "Adım",
    firstUseGuideSkip: "Atla",
    firstUseGuideNext: "İleri",
    firstUseGuideDone: "Tamam",
    firstUseGuideSteps: [
      {
        title: "Konuştuğun dili seç",
        body: "Yönlendirmeleri ve ipuçlarını hangi dilde görmek istediğini seç.",
      },
      {
        title: "Çalışacağın dili seç",
        body: "Konuşma pratiği yapmak istediğin dili seç.",
      },
      {
        title: "Seviye ve senaryo",
        body: "Önce seviyeni seç. Sonra bir çalışma alanı açıp senaryo kartına geç.",
      },
      {
        title: "Hızlı erişim",
        body: "Sık kullandığın ekranlara kenar menüsünden dön. Simge ekranda engel olursa diğer kenara sürükle.",
      },
    ],
    controlledTrialProgressLabel: "Deneme turu",
    controlledTrialStart: "Başla",
    controlledTrialStarting: "Hazırlanıyor",
    controlledTrialPreparing: "Deneme turu hazırlanıyor",
    controlledTrialLockedTag: "Önce deneme turu",
    controlledTrialBlockedTitle: "Önce deneme turunu tamamla",
    controlledTrialBlockedBody: "Bu kısa adımı tamamladığında diğer seçenekler açılacak.",
    controlledTrialBlockedAction: "Tura devam et",
    controlledTrialCompletionTitle: "Tebrikler!",
    controlledTrialCompletionBody: "Artık uygulamayı nasıl kullanacağını biliyorsun.",
    controlledTrialCompletionItems: [
      "Cümle pratiği",
      "Kelime pratiği",
      "Görevler",
      "Görev havuzu",
    ],
    controlledTrialCompletionAction: "Seviyeni seç",
    controlledTrialStages: [
      {
        title: "Önce cümle pratiğini deneyelim",
        body: "Cümleyi dinle, mikrofona dokun ve sesli söyle.",
      },
      {
        title: "Şimdi kelimelerle çalışalım",
        body: "Kelimeyi dinle ve sesli tekrar et.",
      },
      {
        title: "Şimdi gerçek bir görevi deneyelim",
        body: "Durumu gör, diyaloğu dinle ve kendi yanıtını söyle.",
      },
      {
        title: "Son olarak görev havuzunu keşfedelim",
        body: "Görev seç'e dokun, listedeki bir görevi seç ve Görevi aç'a dokun.",
      },
    ],
    controlledTrialVocabularyStages: [
      {
        title: "Önce kelimeyi dinleyip tekrarlayalım",
        body: "Kelimeyi dinle, mikrofona dokun ve sesli tekrar et.",
      },
      {
        title: "Şimdi harfleri doğru sıraya koyalım",
        body: "Karışık harfleri seçerek aynı kelimeyi yeniden oluştur.",
      },
      {
        title: "Son olarak duyduğumuzu yazalım",
        body: "Kelimeyi dinle ve duyduğunu doğru şekilde yaz.",
      },
    ],
    contextGuideDomainTitle: "Nereden başlamalı?",
    contextGuideDomainSteps: [
      {
        title: "Önerilen sıradan başla",
        body: "Kart numaraları önerdiğimiz çalışma sırasını gösterir. Önce tamamlanmamış kartlar arasındaki en düşük numaradan başla.",
      },
      {
        title: "Konu seçimi sende",
        body: "Bugün başka bir konu çalışmak daha uygunsa doğrudan o karta dokun. Numara sadece yol gösterir; seçim sende.",
      },
      {
        title: "Senaryoda da sırayı koru",
        body: "Alanı açınca ilk tamamlanmamış senaryodan başla. Düzenli ilerlemek daha kolay olur.",
      },
    ],
    contextGuideModeTitle: "Bu senaryoda önerilen sıra",
    contextGuideModeSteps: [
      {
        title: "Cümle pratiğiyle başla",
        body: "Cümleleri önce dinle, sonra yüksek sesle söyle. Bu adım, cümleleri kavramanı ve telaffuzunu geliştirmeni sağlar.",
      },
      {
        title: "Kelimeleri pekiştir",
        body: "Senaryodaki önemli kelimeleri bağlamıyla tekrar et.",
      },
      {
        title: "Görevlerle tamamla",
        body: "Cümleleri ve kelimeleri konuşma akışı içinde kullan. Başka sıradan ilerlemek istersen istediğin kartı aç.",
      },
    ],
    contextGuidePracticeTitle: "Cümle pratiğine başlamadan",
    contextGuidePracticeSteps: [
      {
        title: "Bölüm seç",
        body: "Bu ekranda senaryonun cümle bölümleri var. İlk bölüm açık; diğerleri ilerledikçe açılır.",
      },
      {
        title: "Dinle ve söyle",
        body: "Cümleyi dinle. Sonra mikrofona dokunup net şekilde söyle.",
      },
      {
        title: "Sonucu kontrol et",
        body: "Netlik yeterliyse ilerleme kaydedilir. Zor gelen cümleyi tekrar dene.",
      },
    ],
    contextGuideVocabularyTitle: "Kelime pratiğine başlamadan",
    contextGuideVocabularySteps: [
      {
        title: "Kelimeler senaryodan gelir",
        body: "Bu kelimeler, çalıştığın senaryonun cümlelerinden seçildi. Önce bağlamı dinle, sonra kelimeye odaklan.",
      },
      {
        title: "Dinleyerek başla",
        body: "İlk turda dinle ve tekrar et. Ardından yazma ve sıralama egzersizleriyle pekiştir.",
      },
      {
        title: "Sıra esnek",
        body: "İstersen doğrudan başka bir kelime egzersizini aç. Bu sadece önerilen sıra.",
      },
    ],
    contextGuideMissionsTitle: "Görevlere başlarken",
    contextGuideMissionsSteps: [
      {
        title: "Durumu ve hedefi oku",
        body: "Görevin geçtiği durumu ve senden beklenen hedefi önce hedef dilde oku. Gerekirse bayrakla dil desteğini aç.",
      },
      {
        title: "Diyaloğu dinle",
        body: "Örnek diyaloğu sırayla dinle. Hazır olunca aynı hedefi kendi sesinle tamamla.",
      },
      {
        title: "Konuşmayı tamamla",
        body: "Görevi gerçek konuşma provası gibi kullan. Takılırsan yeniden dene; hızını kendin belirle.",
      },
    ],
    contextGuideMixedMissionsTitle: "Karışık görevlere başlamadan",
    contextGuideMixedMissionsSteps: [
      {
        title: "Havuz cihazdaki görevlerden oluşur",
        body: "Bir senaryonun görev seslerini indirdiğinde o görevler bu alana eklenir. Burada yeni içerik indirilmez.",
      },
      {
        title: "Seviye filtresini seç",
        body: "Tek bir seviyeyi seç ya da Tümü ile cihazdaki uygun görevleri karışık aç.",
      },
      {
        title: "Ayrı egzersiz ekranı açılır",
        body: "Her kart seçili görevi normal ders akışına girmeden ayrı bir egzersiz olarak açar. Bitirince bu alana dön ve başka bir tekrar görevi seç.",
      },
    ],
    quickAccessOpenLabel: "Hızlı menüyü aç",
    quickAccessCloseLabel: "Hızlı menüyü kapat",
    quickAccessTitle: "Hızlı erişim",
    quickAccessHint: "Sık kullanılan ekranlara doğrudan geç.",
    quickAccessLanguageSettingsLabel: "Dil Ayarları",
    quickAccessCurrentScenario: "Mevcut senaryo",
    quickAccessMixedMissions: "Karışık görevler",
    quickAccessUnavailableHint: "Önce dil ve seviye seçimini tamamla.",
  },
  en: {
    appKicker: "Wordinarius Echo",
    appTitle: "Speaking Coach",
    setupStep: "Step",
    setupLanguagePairTitle: "Set your language pair",
    setupAppLanguageLabel: "App language",
    setupLanguagePairHint: "",
    setupSpeakLabel: "I speak",
    setupPracticeLabel: "I want to practice",
    setupPickerPlaceholder: "Select language",
    setupContinue: "Continue",
    setupLanguagePairConflictHint: "No practice language is available for this support language yet.",
    setupLanguageApplyingTitle: "Setting up languages",
    setupLanguageApplyingHint: "Preparing language packages and study areas before opening the level screen.",
    setupLanguagePairSummaryTitle: "Check your choices",
    setupLanguagePairNativeSummary: "Language I speak",
    setupLanguagePairTargetSummary: "Practice language",
    setupNativeTitle: "Which language do you want help in?",
    setupNativeHint: "Guidance and hints will be shown in this language.",
    setupTargetTitle: "Which language do you want to learn?",
    setupTargetHint: "You will practice speaking in this language.",
    setupEnglishAccentTitle: "English accent",
    setupEnglishAccentHint: "Choose which accent to use for listening and speech checks.",
    setupAccentAmerican: "American (US)",
    setupAccentBritish: "British (UK)",
    setupLevelTitle: "Which level do you want to start with?",
    setupLevelHint: "Start from the first level for a strong base.",
    setupLevelReadyTag: "Available",
    setupLevelLockedTag: "Soon",
    setupLevelOnlyA1Hint: "A1, A2, B1, and B2 are active right now.",
    setupNativeLanguageLabel: "Language I speak",
    setupNativeLanguageChange: "Change",
    nativeLanguageConfirmTitle: "Confirm language I speak",
    nativeLanguageConfirmQuestion: "Use {languageName} for guidance and hints?",
    nativeLanguageConfirmHint: "This also controls the flag-based help shown beside target-language content.",
    nativeLanguageConfirmCancel: "Change",
    nativeLanguageConfirmConfirm: "Yes, use it",
    setupLevelConfirmHint: "Continue to go straight to the learning areas.",
    setupLevelConfirmCancel: "Cancel",
    setupLevelConfirmLoad: "Continue",
    setupLevelConfirmLoading: "Opening...",
    domainContentPromptTitle: "Content package",
    domainContentPromptQuestion: "Download the scenario content for this area?",
    domainContentPromptHint: "Only the text package for this level and learning area is prepared. Audio opens separately when needed.",
    domainContentPromptInstall: "Download",
    domainContentPromptInstalling: "Preparing content...",
    domainContentPromptError: "This content package could not be prepared right now.",
    cancelLabel: "Cancel",
    okLabel: "OK",
    setupDownloadTitle: "Download required learning packs",
    setupDownloadHint: "Only the files for your selected language and level are downloaded.",
    setupReadyTitle: "Everything is ready",
    setupReadyHint: "You will first see how to speak, then practice step by step.",
    targetLabel: "Target language",
    levelLabel: "Level",
    requiredPacks: "Required packs",
    scenarios: "scenarios",
    sentences: "sentences",
    estimatedSize: "Estimated size",
    downloadNow: "Download now",
    downloading: "Downloading",
    startLearning: "Start learning",
    restartSetup: "Restart setup",
    sessionTitle: "Today's lesson",
    sessionHint: "Flow: Learn -> Practice -> Missions -> Result",
    changeSetup: "Change setup",
    changeDomain: "Choose another area",
    backToLevelScreen: "Back to level screen",
    domainLabel: "Learning area",
    scenarioLabel: "Scenario",
    learnLabel: "Learn",
    practiceLabel: "Practice",
    vocabularyLabel: "Vocabulary",
    dialogueLabel: "Missions",
    resultLabel: "Result",
    previous: "Previous",
    next: "Continue",
    learnTitle: "1) First, see correct usage",
    learnHint: "Listen to model dialogue and learn where to use each phrase.",
    learnRoleSwitchYes: "This scenario includes both asking and answering roles.",
    learnRoleSwitchNo: "This scenario focuses on one role; the other role is trained in another scenario.",
    contextLabel: "Context",
    listen: "Listen",
    practiceTitle: "2) Now you speak",
    practiceHint: "Repeat these phrases out loud to build natural fluency.",
    practiceActionLead: "Tap the microphone and say the sentence out loud.",
    practiceActionStepRead: "1) Read the sentence",
    practiceActionStepSpeak: "2) Tap the microphone below to test",
    practiceActionDone: "Done",
    dialogueTitle: "3) Real-life missions",
    dialogueHint: "Review the mission setup, then produce the expected sentence out loud.",
    dialogueYourTurn: "Your turn",
    resultTitle: "4) Lesson summary",
    resultHint: "You have seen and practiced the core phrases of this scenario.",
    resultRestartLesson: "Restart lesson",
    audioPlaying: "Audio is playing",
    audioError: "Audio could not be played right now. Please try again.",
    packMissingTitle: "Required pack is not ready",
    packMissingHint: "You need to finish download before entering this learning area.",
    goDownload: "Back to download step",
    genericError: "Content could not be loaded right now.",
    startupFailureTitle: "The app could not open",
    startupFailureBody: "Try again, or refresh only the saved navigation position.",
    startupRetry: "Try again",
    startupRepairNavigation: "Refresh navigation",
    startupRepairHint: "Your progress, downloads, and account data are preserved.",
    startupDiagnosticLabel: "Diagnostic code",
    pickDomainTitle: "Choose learning area",
    pickDomainHint: "Start with one area for structured progress.",
    pickScenarioTitle: "Choose your scenario",
    pickScenarioHint: "Pick one scenario and continue in order.",
    pickModeTitle: "Choose learning mode",
    pickModeHint: "Recommended order: sentence practice first, vocabulary practice second, missions last.",
    pickVocabularyTitle: "Choose vocabulary practice",
    pickVocabularyHint: "Choose a card to open the word studio or the vocabulary exercises route.",
    pickVocabularyExercisesTitle: "Choose vocabulary exercises",
    pickVocabularyExercisesHint: "Choose which exercise you want to start with for this scenario.",
    startScenarioLesson: "Start this scenario",
    changeScenario: "Choose another scenario",
    translationMissing: "Support text is not ready for this line yet.",
    dialogLabel: "Dialog",
    listenDialogue: "Listen to full dialog",
    learnNextDialogue: "Next dialog",
    learnOpenDetails: "Show language details",
    learnBackToDialogues: "Back to dialogs",
    practiceTryVoice: "Speak and test",
    practiceStopVoice: "Stop recording",
    practiceListening: "Listening... say the sentence now.",
    practiceProcessing: "Evaluating...",
    practiceTranscript: "What we heard",
    practiceClarity: "Clarity",
    practiceTaskFit: "Sentence match",
    practiceTaskFitMatch: "Matches",
    practiceTaskFitMismatch: "Does not match",
    practiceTaskFitUnknown: "Unclear",
    practiceBandPass: "Clear",
    practiceBandLow: "Partly clear",
    practiceBandFail: "Needs work",
    practiceVoiceUnavailable: "Speech could not start right now. Please try again.",
    practiceSpeechPermissionDenied: "Microphone permission is required to start speech test.",
    practiceSpeechNoMatch: "No speech was detected. Speak closer and retry.",
    practiceSpeechModelPreparing: "The Turkish speech model is being prepared. Wait a moment and try again.",
    practiceSpeechBusy: "Speech recognition is busy. Wait briefly and try again.",
    practiceNextSentence: "Next sentence",
    assistedProgressAction: "Skip to next",
    assistedProgressHint: "This step will not count as completed or earn a reward.",
    practiceChapterLabel: "Chapter",
    practiceIntroFallbackHint: "In this chapter, you will practice the patterns in sequence.",
    practiceLockedShortAdLabel: "Opens with an ad",
    practiceLockedLabel: "Locked",
    practiceStartChapterAction: "Start practice",
    practiceChapterCompleteTitle: "Chapter complete",
    practiceChapterCompleteFinalHint: "You completed all practice chapters. You can move to dialogue missions now.",
    practiceChapterCompleteNextHint: "Nice progress. Continue to the next chapter when you are ready.",
    practiceReplayChapterAction: "Replay chapter",
    practiceGoToMissionsAction: "Go to missions",
    practiceNextChapterAction: "Next chapter",
    practiceCollectedLabel: "Collected",
    practiceTargetSentenceLabel: "Target sentence",
    practiceNoIntentContentState: "No chapter-based practice content was found for this scenario.",
    practiceNoSentenceState: "No practice sentence found for this scenario.",
    vocabularyAudioLabel: "Vocabulary audio",
    missionAudioLabel: "Mission audio",
    sectionAudioLabel: "Audio for this section",
    sentenceAudioLabel: "Sentence audio",
    audioUnlockPromptTitle: "Unlock this pack with an ad",
    audioUnlockPromptMessageTemplate:
      "One ad supports free access to {unitLabel} and downloads it to this device. You will not need another ad for the same pack while it stays ready on this device.",
    audioUnlockPromptCancelLabel: "Not now",
    audioUnlockPromptConfirmLabel: "Watch ad and unlock",
    audioOpenUnavailableTitle: "Can't open right now",
    audioSectionRelockedTitle: "Section locked again",
    audioSectionRelockedMessage: "This section was locked again because the required audio is no longer on this device.",
    simulationSupportHint: "When it is your turn, say the line and test it instantly if needed.",
    simulationLearnerAction: "Say this line out loud",
    simulationShowHint: "Show hint",
    simulationShowAnswer: "Show model answer",
    simulationHintTitle: "Hint",
    simulationAnswerTitle: "Model answer",
    simulationTaskTitle: "Task",
    simulationCompletionRequired: "Complete all mission tasks before continuing.",
    simulationListenFlow: "Listen to flow",
    simulationMissionLabel: "Mission",
    simulationSceneLabel: "Scene",
    simulationGoalLabel: "Goal",
    simulationExpectedSentenceLabel: "Expected sentence",
    simulationStartTitle: "Task",
    simulationStartPromptRespond: "Listen and say the suitable sentence.",
    simulationStartPromptInitiate: "Start the conversation and say the suitable sentence.",
    simulationChoiceHint: "Say the correct sentence from option A or B.",
    simulationStartButton: "I'm ready",
    simulationPreviewReadyButton: "See the dialogue",
    simulationNextTask: "Next task",
    simulationFinishFlow: "Finish missions",
    simulationWaitLabel: "Wait",
    simulationYourTurnLabel: "Your turn",
    simulationReadyNextLabel: "Ready: move to the next task",
    simulationStartRequired: "Start the task first.",
    simulationPreviewListenRequired: "Listen to every line first",
    simulationPreviewReadyLabel: "Ready: start the mission",
    simulationPreviewProgressLabel: "Reviewed lines",
    simulationAutoCountdownLabel: "Mic opens in",
    simulationPreviewSceneGoalBadge: "Mission",
    simulationPreviewDialogueBadge: "Review the dialogue",
    simulationRetryButton: "Retry",
    simulationRetryWrongOption: "I heard you, but that is not the correct option for this task. Please try again.",
    simulationRetryExactMatch: "Try to say only the exact sentence shown on screen.",
    simulationRetryNotClear: "I could not understand clearly. Please try again.",
    simulationPrefixScopeNote: "This try only checked the start of the sentence.",
    simulationCompleteTitle: "Simulation complete",
    simulationCompleteHint: "You progressed with appropriate responses through this flow.",
    simulationNoStepState: "No learner simulation step was found for this scenario.",
    flowLabel: "Mission",
    languageTurkish: "Turkish",
    languageEnglish: "English",
    speakerLearner: "You",
    speakerGuide: "W-Echo",
    domainSocialInteraction: "Social interaction",
    domainDailyLife: "Daily life",
    domainServicesPublic: "Services / Public",
    domainCommunicationRepair: "Communication repair",
    microSkillLabel: "Micro-skill",
    contextsLabel: "Contexts",
    progressLabel: "Progress",
    sequentialRecommendationTitle: "Sequential path recommended",
    sequentialRecommendationMessageTemplate: "It is recommended to complete scenario {scenarioNumber} first.",
    openRecommendedLabel: "Open recommended",
    openAnywayLabel: "Open anyway",
    showAllChoices: "Show all choices",
    missionStatsAccuracy: "Accuracy",
    missionStatsFluency: "Fluency",
    missionStatsStars: "Stars",
    missionStatsXp: "XP",
    diamondsLabel: "W-Coin",
    xpLabel: "XP",
    missionStatsStreak: "Streak",
    statusCompleted: "Completed",
    statusInProgress: "In progress",
    statusNew: "New",
    scenarioTapHint: "Tap to start",
    modeTapHint: "Tap to open",
    openNowTag: "Open now",
    signInRewardedTag: "Sign in + ad",
    guestStarterHint: "The first section is open now. Other audio packs open after sign-in with an ad when needed.",
    vocabularyUnlockHint: "Vocabulary audio opens separately. Locked cards require sign-in first, then an ad.",
    modeCardLearnContent: "Example dialogues",
    modeCardPracticeContent: "Sentence practice",
    modeCardVocabularyContent: "Vocabulary practice",
    modeCardMissionsContent: "Missions",
    modeStatsDialogues: "dialogues",
    modeStatsPrompts: "prompts",
    modeStatsWords: "words",
    modeStatsMissions: "missions",
    modeStatsReviewed: "Reviewed",
    modeStatsCompleted: "Completed",
    mixedMissionsTitle: "Mixed missions",
    mixedMissionsHint: "Open a review pool from mission audio already ready on this device.",
    mixedMissionsLoadingTitle: "Preparing missions",
    mixedMissionsLoadingHint: "Checking downloaded missions on this device. They will appear here shortly.",
    mixedMissionsEmptyTitle: "The pool is empty",
    mixedMissionsEmptyHint: "Downloaded mission audio from a scenario adds those missions here.",
    mixedMissionsReadyTag: "Review ready",
    mixedMissionsUnavailableTag: "Not ready yet",
    mixedMissionsOpenAction: "Open mission",
    mixedMissionsStartMixedAction: "Start mixed mission",
    mixedMissionsPickMissionAction: "Choose mission",
    mixedMissionsPickerTitle: "Choose a mission",
    mixedMissionsPickerCloseAction: "Close mission picker",
    mixedMissionsAllLevelsFilter: "All",
    mixedMissionsLevelFilterLabel: "Level filter",
    vocabularyStudioTitle: "Word studio",
    vocabularyStudioHint: "Listen to each word, say it out loud, and repeat it.",
    vocabularyExercisesTitle: "Vocabulary exercises",
    vocabularyExercisesHint: "Open one of the listening, writing, or word-order exercise paths.",
    vocabularyExerciseListenRepeatTitle: "Listen and repeat",
    vocabularyExerciseListenRepeatHint: "Listen to the word, say it out loud, and repeat it.",
    vocabularyExerciseUnscrambleTitle: "Unscramble",
    vocabularyExerciseUnscrambleHint: "Rebuild the correct word from the mixed letters.",
    vocabularyExerciseListenWriteTitle: "Listen and write",
    vocabularyExerciseListenWriteHint: "Write the word you hear correctly.",
    vocabularyPreviewTitle: "Preview",
    vocabularyAudioReadyLabel: "Audio ready",
    vocabularyAudioPendingLabel: "Audio pending",
    vocabularyContextUnit: "contexts",
    vocabularyEmptyState: "Vocabulary data is not ready for this scenario yet.",
    vocabularyStartAction: "Start",
    vocabularyRestartAction: "Restart",
    vocabularyCheckAction: "Check",
    vocabularyNextWordAction: "Next word",
    vocabularyExamplesAction: "Examples",
    vocabularyHideExamplesAction: "Hide examples",
    vocabularyWordLabel: "Word",
    vocabularyExamplesLabel: "Example sentences",
    vocabularyNoExamplesState: "No example sentence is linked to this word yet.",
    vocabularyListenAction: "Listen",
    vocabularyStopAction: "Stop",
    vocabularyRecognizedLabel: "Recognized word",
    vocabularyWritePlaceholder: "Type the word you hear",
    vocabularyYourAnswerLabel: "Your answer",
    vocabularyCorrectAnswerLabel: "Correct word",
    vocabularyScoreLabel: "XP",
    vocabularyHintOneAction: "Hint 1",
    vocabularyHintTwoAction: "Hint 2",
    vocabularyGiveUpAction: "Give up",
    vocabularyClearAction: "Clear",
    vocabularyBackspaceAction: "Backspace",
    vocabularySpellingHintAction: "Spelling hint",
    vocabularyMeaningHintLabel: "Language help",
    vocabularyAudioHintLabel: "Audio hint",
    vocabularyAudioHintPlayed: "The word audio was played. You can listen again.",
    vocabularyFeedbackCorrect: "Correct",
    vocabularyFeedbackIncorrect: "Not correct yet",
    vocabularyFeedbackGiveUp: "Word revealed",
    vocabularyFeedbackHintLabel: "Practice hint",
    vocabularyFeedbackListenRepeatHint: "Listen again. Say the word in small parts and stay close to the mic.",
    vocabularyFeedbackListenWriteHint: "Listen again. Check the spelling and correct your answer.",
    vocabularyFeedbackUnscrambleHint: "Do not give up yet. Use the hints to narrow down the letter order.",
    vocabularyFeedbackCloseAction: "Close result",
    clarityRailLabel: "Clarity",
    rewardCollectedLabel: "REWARD COLLECTED",
    diamondCollectedLabel: "REWARD COLLECTED",
    statusListeningLabel: "Listening",
    statusProcessingLabel: "Processing",
    statusEvaluatingLabel: "Evaluating",
    retryShortLabel: "Try again",
    genericStatusLabel: "Status",
    genericFeedbackLabel: "Feedback",
    practiceRailListeningHint: "The rail fills as your speech comes through.",
    practiceRailProcessingHint: "Final clarity is being processed.",
    practiceRailPassRewardHint: "Clear delivery. Reward collected.",
    practiceRailPassXpHint: "Clear delivery. New XP collected.",
    practiceRailPassReviewHint: "Clear delivery. Review completed.",
    practiceRailRetryHint: "Tap the microphone and try the same sentence again.",
    missionRailListeningHint: "The clarity rail will move as your line comes in.",
    missionRailProcessingHint: "Final clarity is being processed.",
    missionRailPassRewardHint: "Full clarity. Reward collected.",
    missionRailPassContinueHint: "Mission complete. Continue when you are ready.",
    missionRailIdleHint: "The clarity rail will move as your line comes in.",
    simulationLiveFeedbackListening: "Say your line. Feedback will appear here.",
    simulationLiveFeedbackProcessing: "Your result is being prepared.",
    fullScreenPreviousMissionLabel: "Previous mission",
    fullScreenNextMissionLabel: "Next mission",
    fullScreenPreviousSentenceLabel: "Previous sentence",
    fullScreenNextSentenceLabel: "Next sentence",
    vocabularyTryAgainHint: "Adjust your answer and check again.",
    translateAction: "Translate",
    hideTranslation: "Hide translation",
    translationLoading: "Translating...",
    translationError: "Translation is not available right now.",
    noScenarioSelectedError: "No scenario has been selected yet.",
    firstUseGuideTitle: "Quick start",
    firstUseGuideStepLabel: "Step",
    firstUseGuideSkip: "Skip",
    firstUseGuideNext: "Next",
    firstUseGuideDone: "Done",
    firstUseGuideSteps: [
      {
        title: "Choose the language you speak",
        body: "Choose the language you want to use for guidance and hints.",
      },
      {
        title: "Choose your practice language",
        body: "Choose the language you want to practice speaking.",
      },
      {
        title: "Pick a level and scenario",
        body: "Pick your level first. Then open a learning area and choose a scenario card.",
      },
      {
        title: "Use quick access",
        body: "Use the edge menu to return to key screens. If the icon gets in the way, drag it to the other side.",
      },
    ],
    controlledTrialProgressLabel: "Guided trial",
    controlledTrialStart: "Start",
    controlledTrialStarting: "Getting ready",
    controlledTrialPreparing: "Getting the guided trial ready",
    controlledTrialLockedTag: "Finish the trial first",
    controlledTrialBlockedTitle: "Finish the guided trial first",
    controlledTrialBlockedBody: "The other choices will open after this short step.",
    controlledTrialBlockedAction: "Continue the trial",
    controlledTrialCompletionTitle: "Congratulations!",
    controlledTrialCompletionBody: "You now know how to use the app.",
    controlledTrialCompletionItems: [
      "Sentence practice",
      "Vocabulary practice",
      "Missions",
      "Mission pool",
    ],
    controlledTrialCompletionAction: "Choose your level",
    controlledTrialStages: [
      {
        title: "First, try sentence practice",
        body: "Listen to the sentence, tap the microphone, and say it out loud.",
      },
      {
        title: "Now, work with the words",
        body: "Listen to the word and repeat it out loud.",
      },
      {
        title: "Now, try a real mission",
        body: "See the situation, listen to the dialogue, and give your own response.",
      },
      {
        title: "Finally, discover your mission pool",
        body: "Tap Choose mission, select one downloaded task, then tap Open mission.",
      },
    ],
    controlledTrialVocabularyStages: [
      {
        title: "First, listen and repeat",
        body: "Listen to the word, tap the microphone, and repeat it out loud.",
      },
      {
        title: "Now, put the letters in order",
        body: "Choose the mixed letters to rebuild the same word.",
      },
      {
        title: "Finally, write what you hear",
        body: "Listen to the word and type it correctly.",
      },
    ],
    contextGuideDomainTitle: "Where to start",
    contextGuideDomainSteps: [
      {
        title: "Start with the numbered path",
        body: "The numbers mark the recommended order. Open the lowest-numbered unfinished card first.",
      },
      {
        title: "Choose another topic when needed",
        body: "If another topic fits today better, open that card directly. Treat the number as guidance, not a lock.",
      },
      {
        title: "Keep the same rhythm",
        body: "After opening an area, start with the first unfinished scenario. It keeps progress easier to follow.",
      },
    ],
    contextGuideModeTitle: "Recommended order for this scenario",
    contextGuideModeSteps: [
      {
        title: "Start with sentence practice",
        body: "Listen to the sentences first, then say them out loud. This helps you understand the sentences and improve your pronunciation.",
      },
      {
        title: "Reinforce the words",
        body: "Review the key words from this scenario in context.",
      },
      {
        title: "Finish with missions",
        body: "Use the sentences and words in a real speaking flow. Open another card if you want a different order.",
      },
    ],
    contextGuidePracticeTitle: "Before sentence practice",
    contextGuidePracticeSteps: [
      {
        title: "Choose a section",
        body: "This screen contains the sentence sections for the scenario. Start with the open section, then unlock the rest as you progress.",
      },
      {
        title: "Listen, then speak",
        body: "Listen to the sentence. Then tap the microphone and say it clearly.",
      },
      {
        title: "Check the result",
        body: "When clarity is strong enough, progress is saved. Repeat any sentence that feels difficult.",
      },
    ],
    contextGuideVocabularyTitle: "Before vocabulary practice",
    contextGuideVocabularySteps: [
      {
        title: "Words come from the scenario",
        body: "Each word comes from the scenario sentences. Listen to the context first, then focus on the word.",
      },
      {
        title: "Start with listening",
        body: "Begin with listen-and-repeat. Then reinforce the word with writing and ordering exercises.",
      },
      {
        title: "Use the order as a guide",
        body: "Open another vocabulary exercise directly if that fits your session better. This is only the recommended order.",
      },
    ],
    contextGuideMissionsTitle: "Before missions",
    contextGuideMissionsSteps: [
      {
        title: "Read the situation and goal",
        body: "Read the situation and goal in the language you are learning. Use the flag when you need support in your own language.",
      },
      {
        title: "Prepare with the dialogue",
        body: "Listen to the sample dialogue in order. When ready, complete the same goal with your own voice.",
      },
      {
        title: "Complete the exchange",
        body: "Use the mission as real speaking practice. If you get stuck, try again at your own pace.",
      },
    ],
    contextGuideMixedMissionsTitle: "Before mixed missions",
    contextGuideMixedMissionsSteps: [
      {
        title: "The pool uses device audio",
        body: "Downloaded mission audio adds that mission to this area. No extra content is created here.",
      },
      {
        title: "Choose the level filter",
        body: "Pick one level, or use All to open a task from every available level on this device.",
      },
      {
        title: "Review in a separate exercise",
        body: "Each card opens the selected mission as a separate exercise, without entering the normal lesson flow. Finish it, then return here for another review task.",
      },
    ],
    quickAccessOpenLabel: "Open quick menu",
    quickAccessCloseLabel: "Close quick menu",
    quickAccessTitle: "Quick access",
    quickAccessHint: "Jump directly to common screens.",
    quickAccessLanguageSettingsLabel: "Language settings",
    quickAccessCurrentScenario: "Current scenario",
    quickAccessMixedMissions: "Mixed missions",
    quickAccessUnavailableHint: "Finish language and level setup first.",
  },
};

const SETUP_LEVEL_SUBTITLES: Record<SupportedUiLanguage, SetupLevelSubtitleCopy> = {
  ar: AR_SETUP_LEVEL_SUBTITLES,
  tr: {
    a1: "Başlangıç",
    a2: "Temel",
    b1: "Orta",
    b2: "Orta üstü",
  },
  en: {
    a1: "Beginner",
    a2: "Elementary",
    b1: "Intermediate",
    b2: "Upper Intermediate",
  },
};

const BACKEND_SMOKE_COPY: Record<SupportedUiLanguage, BackendSmokeCopy> = {
  ar: AR_BACKEND_SMOKE_COPY,
  tr: {
    title: "Sistem kontrolü",
    run: "Kontrolü çalıştır",
    idle: "Hazır",
    running: "Çalışıyor...",
    success: "Kontrol tamamlandı",
    error: "Kontrol tamamlanamadı",
    hint: "Bu dahili kontrol, giriş ve ses hazırlığı akışını sırayla dener.",
    uid: "hesap",
    attemptId: "deneme",
    endpoint: "bağlantı",
    authPresent: "giriş hazır",
    providerIds: "girişler",
    downloadAuthorized: "indirme hazır",
    authorizationSource: "erişim türü",
    scenario: "senaryo",
    errorCode: "hata",
    phase: "aşama",
  },
  en: {
    title: "System check",
    run: "Run check",
    idle: "Idle",
    running: "Running...",
    success: "Check completed",
    error: "Check could not finish",
    hint: "This internal check walks through sign-in and audio preparation.",
    uid: "account",
    attemptId: "attempt",
    endpoint: "connection",
    authPresent: "sign-in ready",
    providerIds: "sign-ins",
    downloadAuthorized: "download ready",
    authorizationSource: "access type",
    scenario: "scenario",
    errorCode: "error",
    phase: "phase",
  },
};

const REMOTE_AUDIO_INSTALL_SMOKE_COPY: Record<SupportedUiLanguage, RemoteAudioInstallSmokeCopy> = {
  ar: AR_REMOTE_AUDIO_INSTALL_SMOKE_COPY,
  tr: {
    title: "Ses hazırlık kontrolü",
    run: "Kontrolü çalıştır",
    idle: "Hazır",
    running: "Çalışıyor...",
    success: "Kontrol tamamlandı",
    error: "Kontrol tamamlanamadı",
    hint: "Bu dahili kontrol, gerekli sesleri indirip cihazda hazır olup olmadığını doğrular.",
    uid: "hesap",
    providerIds: "girişler",
    authorizationSource: "erişim türü",
    fileStoreVerified: "sesler hazır",
    audioRefCount: "ses sayısı",
    newlyInstalledAudioRefCount: "yeni inen ses",
    alreadyInstalledAudioRefCount: "hazır olan ses",
    playableSourceKind: "kaynak",
    playableUri: "oynatma adresi",
    storageUnitKey: "paket",
    scenario: "senaryo",
    errorCode: "hata",
    phase: "aşama",
  },
  en: {
    title: "Audio preparation check",
    run: "Run check",
    idle: "Idle",
    running: "Running...",
    success: "Check completed",
    error: "Check could not finish",
    hint: "This internal check downloads the needed audio and confirms it is ready on the device.",
    uid: "account",
    providerIds: "sign-ins",
    authorizationSource: "access type",
    fileStoreVerified: "audio ready",
    audioRefCount: "audio count",
    newlyInstalledAudioRefCount: "new audio",
    alreadyInstalledAudioRefCount: "ready audio",
    playableSourceKind: "source",
    playableUri: "playback link",
    storageUnitKey: "package",
    scenario: "scenario",
    errorCode: "error",
    phase: "phase",
  },
};

const REWARDED_AD_UNLOCK_SMOKE_COPY: Record<SupportedUiLanguage, RewardedAdUnlockSmokeCopy> = {
  ar: AR_REWARDED_AD_UNLOCK_SMOKE_COPY,
  tr: {
    title: "Reklamla açılış kontrolü",
    run: "Kontrolü çalıştır",
    idle: "Hazır",
    running: "Çalışıyor...",
    success: "Kontrol tamamlandı",
    error: "Kontrol tamamlanamadı",
    hint: "Bu dahili kontrol, ödüllü reklamdan sonra bölümün açılıp açılmadığını doğrular.",
    uid: "hesap",
    providerIds: "girişler",
    kind: "sonuç",
    grantedReceiptActive: "erişim açık",
    rewardStatus: "video sonucu",
    adUnitId: "video alanı",
    audioRefCount: "ses sayısı",
    newlyInstalledAudioRefCount: "yeni inen ses",
    alreadyInstalledAudioRefCount: "hazır olan ses",
    fileStoreVerified: "sesler hazır",
    playableSourceKind: "kaynak",
    playableUri: "oynatma adresi",
    storageUnitKey: "paket",
    scenario: "senaryo",
    errorCode: "hata",
    phase: "aşama",
  },
  en: {
    title: "Rewarded-ad unlock check",
    run: "Run check",
    idle: "Idle",
    running: "Running...",
    success: "Check completed",
    error: "Check could not finish",
    hint: "This internal check confirms that a rewarded ad can open the section and prepare its audio.",
    uid: "account",
    providerIds: "sign-ins",
    kind: "kind",
    grantedReceiptActive: "access open",
    rewardStatus: "video result",
    adUnitId: "video slot",
    audioRefCount: "audio count",
    newlyInstalledAudioRefCount: "new audio",
    alreadyInstalledAudioRefCount: "ready audio",
    fileStoreVerified: "audio ready",
    playableSourceKind: "source",
    playableUri: "playback link",
    storageUnitKey: "package",
    scenario: "scenario",
    errorCode: "error",
    phase: "phase",
  },
};

const REWARDED_UNLOCK_PROMPT_COPY: Record<SupportedUiLanguage, RewardedUnlockPromptCopy> = {
  ar: AR_REWARDED_UNLOCK_PROMPT_COPY,
  tr: {
    title: "Bu paketi reklamla aç",
    message: "Bir reklam bu ses paketini ücretsiz kullanıma açar. Paket bu cihazda hazır kaldıkça aynı paket için yeniden reklam gerekmez.",
    cancelLabel: "Şimdi değil",
    confirmLabel: "Reklamı izle ve aç",
  },
  en: {
    title: "Unlock this pack with an ad",
    message: "One ad supports free access to this audio pack. You will not need another ad while the pack stays ready on this device.",
    cancelLabel: "Not now",
    confirmLabel: "Watch ad and unlock",
  },
};

const PROVIDER_INTERACTIVE_PROMPT_COPY: Record<SupportedUiLanguage, ProviderInteractivePromptCopy> = {
  ar: AR_PROVIDER_INTERACTIVE_PROMPT_COPY,
  tr: {
    title: "Giriş yap ve daha fazla sesi aç",
    messageTemplate:
      "İlk içerikler hesapsız açık. {provider} ile devam edersen daha fazla sesi açabilir ve ilerlemeni bu hesaba kaydedebilirsin.",
    confirmLabel: "Devam et",
    cancelLabel: "Şimdi değil",
  },
  en: {
    title: "Sign in to unlock more audio",
    messageTemplate:
      "The first activities stay open without sign-in. Continue with {provider} to open more audio and save your progress to this account.",
    confirmLabel: "Continue",
    cancelLabel: "Not now",
  },
};

const MICROPHONE_PERMISSION_COPY: Record<SupportedUiLanguage, MicrophonePermissionCopy> = {
  ar: AR_MICROPHONE_PERMISSION_COPY,
  tr: {
    title: "Mikrofon izni",
    message: "Konuşma pratiği için mikrofon izni gerekiyor.",
    buttonPositive: "İzin ver",
    buttonNegative: "Vazgeç",
  },
  en: {
    title: "Microphone Access",
    message: "Microphone access is required for speaking practice.",
    buttonPositive: "Allow",
    buttonNegative: "Cancel",
  },
};

const ACCOUNT_UI_COPY: Record<SupportedUiLanguage, AccountUiCopy> = {
  ar: AR_ACCOUNT_UI_COPY,
  tr: {
    domainButton: "Profil",
    title: "Profil ve hesap",
    hint: "Misafir olarak devam edebilirsin. Giriş yaptığında açtığın içerikler ve ilerlemen bu hesaba bağlanır.",
    noteAndroid: "Bu cihazda Google ile giriş yapabilirsin.",
    noteIos: "Bu cihazda Apple ile giriş yapabilirsin.",
    back: "Geri",
    status: "Durum",
    notSignedIn: "Misafir modundasın",
    signedIn: "Hesabın bağlı",
    checking: "Hesabın hazırlanıyor",
    signingIn: "Giriş yapılıyor",
    signingOut: "Çıkış yapılıyor",
    deletingAccount: "Hesap siliniyor",
    authError: "Giriş işlemi tamamlanamadı",
    phase: "Şu an",
    approvedProvider: "Giriş yöntemi",
    level: "Seviye",
    spokenLanguage: "Konuştuğum dil",
    changeSpokenLanguage: "Konuştuğum dili değiştir",
    targetLanguage: "Hedef dil",
    signedInBody: "Açtığın içerikler ve ilerlemen bu hesapla korunur.",
    signedOutBody: "İlk bölümler açık kalır. Diğer sesler için giriş yapman gerekir.",
    guestAccessTitle: "Şimdi açık",
    guestAccessBody: "İlk bölümler, senaryo gezintisi ve temel deneme akışı.",
    protectedFeaturesTitle: "Girişten sonra açılanlar",
    protectedFeaturesBody: "Kilitli sesler ve görevler girişten sonra reklamla açılabilir. Açılan paket cihazda hazır kaldıkça aynı paket yeniden reklam istemez.",
    premiumTitle: "Premium",
    premiumBody: "Premium otomatik yenilenen aylık aboneliktir. Aktif abonelik süresince reklamlar kaldırılır ve kilitli sesler doğrudan açılır.",
    premiumActionLabel: "Premium'u aç",
    premiumRestoreLabel: "Satın alımları geri yükle",
    premiumManageLabel: "Aboneliği yönet",
    premiumRestoreEmptyMessage: "Geri yüklenecek aktif premium satın alımı bulunamadı.",
    premiumSubscriptionPeriodLabel: "Süre",
    premiumSubscriptionPeriodValue: "1 ay, otomatik yenilenir",
    premiumSubscriptionPriceLabel: "Fiyat",
    premiumSubscriptionPriceFallback: "Fiyat, satın alma onayından önce mağaza ekranında gösterilir",
    premiumSubscriptionIncludedLabel: "Dahil olanlar",
    premiumSubscriptionIncludedValue: "Her aktif abonelik döneminde reklamlar kaldırılır ve kilitli sesler doğrudan açılır.",
    premiumSubscriptionRenewalNote: "Abonelik, App Store veya Google Play hesap ayarlarından iptal edilene kadar aylık yenilenir.",
    premiumRestoreHint: "Zaten aboneysen bu cihazda erişimini geri yüklemek için satın alımları geri yükle.",
    premiumLegalText: "Abone olarak Kullanım Şartları ve Gizlilik Politikası'nı kabul etmiş olursun.",
    premiumTermsLabel: "Kullanım Şartları",
    premiumPrivacyLabel: "Gizlilik Politikası",
    adPrivacyOptionsLabel: "Reklam gizliliği tercihleri",
    planLabel: "Plan",
    planFreeValue: "Ücretsiz",
    planPremiumValue: "Premium",
    adsLabel: "Reklam",
    adsOnValue: "Açık",
    adsOffValue: "Kapalı",
    premiumStatusLabel: "Erişim",
    premiumStatusInactiveValue: "Kapalı",
    premiumStatusActiveValue: "Aktif",
    premiumStatusGraceValue: "Ödeme bekleniyor",
    premiumCheckoutLabel: "Satın alma durumu",
    premiumCheckoutReadyValue: "Hazır",
    premiumCheckoutPreparingValue: "Hazırlanıyor",
    premiumCheckoutUnavailableValue: "Henüz hazır değil",
    remindersTitle: "Hatırlatmalar",
    remindersBody: "Kaldığın senaryo, cümle pratiği, görev veya kelime tekrarını seçtiğin sıklıkta hatırlatır. Varsayılan saat 19:00.",
    remindersStatusLabel: "Hatırlatma",
    remindersOnValue: "Açık",
    remindersOffValue: "Kapalı",
    remindersPermissionDeniedValue: "İzin kapalı",
    remindersEnableLabel: "Hatırlatmaları aç",
    remindersDisableLabel: "Hatırlatmaları kapat",
    remindersPreviewLabel: "Bildirim içeriği",
    remindersFrequencyLabel: "Sıklık",
    remindersDailyValue: "Her gün",
    remindersWeeklyValue: "Haftada bir",
    remindersChangeFrequencyLabel: "Sıklığı değiştir",
    remindersTimeLabel: "Saat",
    remindersChangeTimeLabel: "Saati değiştir",
    remindersScheduledLabel: "Sıradaki",
    remindersNotScheduledValue: "Planlanmadı",
    remindersPermissionPromptTitle: "Çalışma hatırlatmaları",
    remindersPermissionPromptMessage: "Kaldığın egzersizi unutma diye sana nazik hatırlatmalar gönderebiliriz. Bildirim izni verirsen bunu seçtiğin sıklıkta yaparız.",
    remindersPermissionPromptConfirm: "Bildirimlere izin ver",
    remindersPermissionPromptCancel: "Şimdi değil",
    appearanceTitle: "Tema",
    settingsTitle: "Ayarlar",
    appearanceBody: "Atelier, açık ya da koyu temayı seç.",
    appearanceModeLabel: "Tema",
    appearanceDarkValue: "Koyu",
    appearanceLightValue: "Açık",
    appearanceFrequencyValue: "Frekans",
    monetizationCheckingValue: "Kontrol ediliyor",
    uid: "Hesap",
    providerIds: "Bağlı girişler",
    signInGoogle: "Google ile devam et",
    signInApple: "Apple ile devam et",
    refreshSession: "Oturumu yenile",
    signOut: "Çıkış yap",
    lazyPromptTitle: "Nasıl açmak istersin?",
    lazyPromptMessage: "{provider} ile giriş yapıp bir reklamla bu paketi aç veya Premium ile reklamsız devam et.",
    lazyPromptConfirm: "Devam et",
    lazyPromptCancel: "Şimdi değil",
    errorTitle: "Bir sorun oldu",
    signOutConfirmTitle: "Çıkış yapılsın mı?",
    signOutConfirmMessage: "Bu cihazdaki hesap bağlantısı kapatılacak.",
    signOutConfirmCancel: "Vazgeç",
    signOutConfirmApprove: "Çıkış yap",
    deleteAccountTitle: "Hesabı sil",
    deleteAccountBody: "Hesabını silersen ilerlemen, kilit açma kayıtların ve hesap bağlantın kaldırılır. Aktif aboneliğin varsa mağaza üzerinden ayrıca iptal etmen gerekir.",
    deleteAccountAction: "Hesabımı sil",
    deleteAccountConfirmTitle: "Hesap silinsin mi?",
    deleteAccountConfirmMessage: "Bu işlem hesabını ve ilerleme verilerini kalıcı olarak kaldırır. Aktif aboneliğin varsa Google Play veya App Store üzerinden ayrıca iptal etmelisin.",
    deleteAccountConfirmCancel: "Vazgeç",
    deleteAccountConfirmApprove: "Eminim, sil",
    deleteAccountSuccessTitle: "Hesap silindi",
    deleteAccountSuccessMessage: "Hesap bağlantın ve ilerleme verilerin kaldırıldı. Uygulamayı misafir olarak kullanmaya devam edebilirsin.",
    providerGoogleLabel: "Google",
    providerAppleLabel: "Apple",
    providerGenericLabel: "Sağlayıcı",
  },
  en: {
    domainButton: "Profile",
    title: "Profile & account",
    hint: "You can keep going as a guest. Once you sign in, your unlocked content and progress stay tied to this account.",
    noteAndroid: "You can sign in with Google on this device.",
    noteIos: "You can sign in with Apple on this device.",
    back: "Back",
    status: "Status",
    notSignedIn: "You are browsing as a guest",
    signedIn: "Account connected",
    checking: "Preparing your account",
    signingIn: "Signing you in",
    signingOut: "Signing out",
    deletingAccount: "Deleting account",
    authError: "Sign-in could not be completed",
    phase: "Right now",
    approvedProvider: "Sign-in method",
    level: "Level",
    spokenLanguage: "Language I speak",
    changeSpokenLanguage: "Change language I speak",
    targetLanguage: "Target language",
    signedInBody: "Your unlocked content and progress stay tied to this account.",
    signedOutBody: "The first sections stay open. Locked audio needs sign-in.",
    guestAccessTitle: "Open now",
    guestAccessBody: "The first sections, scenario browsing, and the core trial flow.",
    protectedFeaturesTitle: "Opens after sign-in",
    protectedFeaturesBody: "Locked audio and missions can open with an ad after sign-in. The same pack does not require another ad while it stays ready on this device.",
    premiumTitle: "Premium",
    premiumBody: "Premium is an auto-renewable monthly subscription. While active, it removes ads and opens locked audio directly.",
    premiumActionLabel: "Open premium",
    premiumRestoreLabel: "Restore purchases",
    premiumManageLabel: "Manage subscription",
    premiumRestoreEmptyMessage: "No active premium purchases were found to restore.",
    premiumSubscriptionPeriodLabel: "Length",
    premiumSubscriptionPeriodValue: "1 month, auto-renewing",
    premiumSubscriptionPriceLabel: "Price",
    premiumSubscriptionPriceFallback: "Shown in the store purchase sheet before confirmation",
    premiumSubscriptionIncludedLabel: "Included",
    premiumSubscriptionIncludedValue: "Ads are removed and locked audio opens directly during each active subscription period.",
    premiumSubscriptionRenewalNote: "Your subscription renews monthly until canceled in your App Store or Google Play account settings.",
    premiumRestoreHint: "Already subscribed? Restore purchases to recover access on this device.",
    premiumLegalText: "By subscribing, you agree to the Terms of Use and Privacy Policy.",
    premiumTermsLabel: "Terms of Use",
    premiumPrivacyLabel: "Privacy Policy",
    adPrivacyOptionsLabel: "Ad privacy choices",
    planLabel: "Plan",
    planFreeValue: "Free",
    planPremiumValue: "Premium",
    adsLabel: "Ads",
    adsOnValue: "On",
    adsOffValue: "Off",
    premiumStatusLabel: "Access",
    premiumStatusInactiveValue: "Inactive",
    premiumStatusActiveValue: "Active",
    premiumStatusGraceValue: "Payment pending",
    premiumCheckoutLabel: "Purchase status",
    premiumCheckoutReadyValue: "Ready",
    premiumCheckoutPreparingValue: "Preparing",
    premiumCheckoutUnavailableValue: "Not ready yet",
    remindersTitle: "Reminders",
    remindersBody: "We remind you about the scenario, sentence practice, missions, or vocabulary review you left open at the frequency you choose. The default time is 19:00.",
    remindersStatusLabel: "Reminder",
    remindersOnValue: "On",
    remindersOffValue: "Off",
    remindersPermissionDeniedValue: "Permission off",
    remindersEnableLabel: "Turn on reminders",
    remindersDisableLabel: "Turn off reminders",
    remindersPreviewLabel: "Notification text",
    remindersFrequencyLabel: "Frequency",
    remindersDailyValue: "Daily",
    remindersWeeklyValue: "Weekly",
    remindersChangeFrequencyLabel: "Change frequency",
    remindersTimeLabel: "Time",
    remindersChangeTimeLabel: "Change time",
    remindersScheduledLabel: "Next",
    remindersNotScheduledValue: "Not scheduled",
    remindersPermissionPromptTitle: "Study reminders",
    remindersPermissionPromptMessage: "We can send gentle reminders so you do not lose the exercise you left open. Allow notifications to receive them at your chosen frequency.",
    remindersPermissionPromptConfirm: "Allow notifications",
    remindersPermissionPromptCancel: "Not now",
    appearanceTitle: "Theme",
    settingsTitle: "Settings",
    appearanceBody: "Choose Atelier, Light, or Dark.",
    appearanceModeLabel: "Theme",
    appearanceDarkValue: "Dark",
    appearanceLightValue: "Light",
    appearanceFrequencyValue: "Frequency",
    monetizationCheckingValue: "Checking",
    uid: "Account",
    providerIds: "Connected sign-ins",
    signInGoogle: "Continue with Google",
    signInApple: "Continue with Apple",
    refreshSession: "Refresh session",
    signOut: "Sign out",
    lazyPromptTitle: "How do you want to unlock it?",
    lazyPromptMessage: "Continue with {provider} and use one ad to unlock this pack, or continue ad-free with Premium.",
    lazyPromptConfirm: "Continue",
    lazyPromptCancel: "Not now",
    errorTitle: "Something went wrong",
    signOutConfirmTitle: "Sign out?",
    signOutConfirmMessage: "This will remove the account connection on this device.",
    signOutConfirmCancel: "Cancel",
    signOutConfirmApprove: "Sign out",
    deleteAccountTitle: "Delete account",
    deleteAccountBody: "Deleting your account removes your progress, unlock records, and account connection. Any active subscription must still be cancelled in the store.",
    deleteAccountAction: "Delete my account",
    deleteAccountConfirmTitle: "Delete account?",
    deleteAccountConfirmMessage: "This permanently removes your account and progress data. If you have an active subscription, cancel it separately in Google Play or the App Store.",
    deleteAccountConfirmCancel: "Cancel",
    deleteAccountConfirmApprove: "Delete account",
    deleteAccountSuccessTitle: "Account deleted",
    deleteAccountSuccessMessage: "Your account connection and progress data were removed. You can keep using the app as a guest.",
    providerGoogleLabel: "Google",
    providerAppleLabel: "Apple",
    providerGenericLabel: "Provider",
  },
};

export function resolveCopyLanguage(languageCode?: string | null): SupportedUiLanguage {
  const normalized = String(languageCode || "").trim().toLowerCase();
  if ((SUPPORTED_UI_LANGUAGES as readonly string[]).includes(normalized)) {
    return normalized as SupportedUiLanguage;
  }
  return "en";
}

export function getCopy(languageCode?: string | null): Copy {
  return COPY[resolveCopyLanguage(languageCode)];
}

export function getSetupLevelSubtitles(languageCode?: string | null): SetupLevelSubtitleCopy {
  return SETUP_LEVEL_SUBTITLES[resolveCopyLanguage(languageCode)];
}

export function getBackendSmokeCopy(languageCode?: string | null): BackendSmokeCopy {
  return BACKEND_SMOKE_COPY[resolveCopyLanguage(languageCode)];
}

export function getRemoteAudioInstallSmokeCopy(languageCode?: string | null): RemoteAudioInstallSmokeCopy {
  return REMOTE_AUDIO_INSTALL_SMOKE_COPY[resolveCopyLanguage(languageCode)];
}

export function getRewardedAdUnlockSmokeCopy(languageCode?: string | null): RewardedAdUnlockSmokeCopy {
  return REWARDED_AD_UNLOCK_SMOKE_COPY[resolveCopyLanguage(languageCode)];
}

export function getRewardedUnlockPromptCopy(languageCode?: string | null): RewardedUnlockPromptCopy {
  return REWARDED_UNLOCK_PROMPT_COPY[resolveCopyLanguage(languageCode)];
}

export function getProviderInteractivePromptCopy(languageCode?: string | null): ProviderInteractivePromptCopy {
  return PROVIDER_INTERACTIVE_PROMPT_COPY[resolveCopyLanguage(languageCode)];
}

export function getMicrophonePermissionCopy(languageCode?: string | null): MicrophonePermissionCopy {
  return MICROPHONE_PERMISSION_COPY[resolveCopyLanguage(languageCode)];
}

export function getAccountUiCopy(languageCode?: string | null): AccountUiCopy {
  return ACCOUNT_UI_COPY[resolveCopyLanguage(languageCode)];
}
